import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-nested-sidebar-fttxponnetworkstestsolutionsguide',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-fttxponnetworkstestsolutionsguide.component.scss']
})
export class NestedSidebarFttxponnetworkstestsolutionsguideComponent implements OnInit {

  constructor(
    public _httpService: HttpService
    ) { }

    pdf = {
      pdfTitle: 'FTTx/PON Networks Test Solutions Application Guide',
      pdfimg: './assets/images/sidebar/D08-00-115_A00_PON_Solution_Guide_FINAL.webp',
      url: 'fttponnettestsolappguide',
      opt: 'BUTTON.DOWNLOAD',
      width: '600',
      height: '776'
    };
  ngOnInit(): void {
  }

}
